import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  // Check for the in-memory accessToken, not the old token
  const { accessToken, loading } = useAuth();

  // Do not make a decision while the initial session check is running
  if (loading) {
    return null; // Or a loading spinner
  }

  return accessToken ? children : <Navigate to="/login" />;
};

export default PrivateRoute;